@use '../cuesheetRows' as rows;
@include rows.cuesheet-row-columns;

.delayRow {
  color: $ontime-delay-text;
  border-left: 4px solid transparent;

  &[data-cursor='true'] {
    outline: 2px solid $blue-500;
    outline-offset: -2px;
    background: color-mix(in srgb, transparent 80%, var(--user-bg, $gray-500) 20%);
  }

  td {
    width: calc(100% - 4px);
    padding-block: 0.5rem;
    text-align: center;

    &:first-letter {
      text-transform: uppercase;
    }
  }
}

.delayRowHidden {
  visibility: hidden;

  td {
    padding: 0;
    height: 1px;
    line-height: 1px;
    font-size: 0;
  }
}
